import {
  RenderingServices,
  FetcherUtils,
} from '@wallaby-ui/core';
import React from 'react';
import {EntityLinkProps} from 'src/js/containers/file/file_types';

export interface BaseEntityLinkParamsType extends EntityLinkProps {
  hrefTo: string;
  isAllowed: boolean;
  children?: React.ReactNode;
}

export function baseEntityLinkParams(
  params: EntityLinkProps,
  _services: RenderingServices = {},
  _displayName: string = ''
): BaseEntityLinkParamsType {
  const {route, id = null, searchParams = {}} = params;
  const encodedSearchParams =
    FetcherUtils.transformJSONToUrlEncodedParams(searchParams);
  const newPathName = `${route}${id ? `/${encodeURIComponent(id)}` : ''}`;
  const hrefTo = `${newPathName}${encodedSearchParams ? '?' : ''}${encodedSearchParams}`;
  const isAllowed = true;

  return {...params, hrefTo, isAllowed};
}
